import LGAPI from './_lg.js';
import httpClient from '@/apis/base/httpclient';

class VoucherAPI extends LGAPI {
  constructor() {
    super();
  }
  controllerName = 'Voucher';

  /**
   * Ghi sổ
   */
  posted(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Bỏ Ghi sổ
   */
  unPosted(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }
  /**
   * Ghi sổ theo lô
   */
  postBatch(payload) {
    const request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Bỏ ghi sổ theo lô
   */
  unPostBatch(payload) {
    const request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }
  /**
   * Ghi sổ theo lô
   */
  postMulti(payload) {
    const request = {
      url: this.getAPIUrl() + '/multi',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Bỏ ghi sổ theo lô
   */
  unPostMulti(payload) {
    const request = {
      url: this.getAPIUrl() + '/multi',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }
  /**
   * Lấy thông tin số dư
   * @param {*} payload
   * @returns
   */
  getRemainingAmount(payload) {
    const request = {
      url: this.getAPIUrl() + '/remainingamount',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Lấy thông tin tồn kho vật tư
   * @param {*} payload
   * @returns
   */
  getQuantityInStock(payload) {
    const request = {
      url: this.getAPIUrl() + '/quantityinstock',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new VoucherAPI();
